import {Injectable} from '@angular/core';
import {User} from '../interfaces/user';
import {SessionService} from "./session.service";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private sessionService: SessionService,
  ) {
  }

  getCurrentUser(): User {
    const user = <User>this.sessionService.get()?.user;

    if (!user) {
      console.error('User not found');
    }

    return user;
  }

  isCurrentUserManager() {
    const user = this.getCurrentUser()

    return user.userRole.includes('MANAGER');
  }

  isCurrentUserSuperAdmin() {
    const user = this.getCurrentUser()

    return user.userRole.includes('SUPER_ADMIN');
  }

  isCurrentUserGlobal() {
    const user = this.getCurrentUser()

    return user?.role === 'global'
  }

  generateHashUser() {
    const user = this.getCurrentUser();

    if (!user) {
      console.log('User not found');
      return '';
    }

    return btoa(`${user.email}:${user.password}`);
  }

  userHasCustomPermission(permission: string) {
    const user = this.getCurrentUser()
    if([20549, 18683].includes(user.id)){
      return true
    }
    return user.userRole.includes(permission)
  }
}
